<div class="tab-area-wrapper">
    <div class="distance-contain"
        *ngIf="attributeDataList?.length || statisticsData.length || masterLeafletData.length">
        <div *ngIf="tabData?.attribute">
            <div *ngIf="attributeDataList?.length">
                <app-line-chart [lineData]="attributeDataList"> </app-line-chart>
            </div>
            <div *ngIf="!attributeDataList?.length">
                <div class="d-flex justify-content-center align-items-center">
                    <div class="text-center image-style"> <img src="../../../assets/images/nodata.svg" alt="no-data">
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!tabData?.attribute">
            <div *ngIf="masterLeafletData.length">
                <app-leaflet-map pageType="profile" [mapData]="masterLeafletData">
                </app-leaflet-map>
            </div>
            <div *ngIf="!masterLeafletData.length">

            </div>
        </div>
        <div class="distance-contain-cont2" *ngIf="statisticsData.length">
            <!-- <div class=" d-flex">
                        <div class="vehicle-profile-header">Distance Static</div>
                        <div class="dropdown ml-auto mb-2">
                            <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                Dropdown button
                            </button>
                            <ul class="dropdown-menu">
                                <li><a class="dropdown-item" href="#">Action</a></li>
                                <li><a class="dropdown-item" href="#">Another action</a></li>
                                <li><a class="dropdown-item" href="#">Something else here</a></li>
                            </ul>
                        </div>
                    </div> -->
            <!-- <div class="d-flex align-items-center mb-2">
                        <div>Select Duration</div>
                        <div class=" ml-auto d-flex">
                            <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    Dropdown button
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="#">Action</a></li>
                                    <li><a class="dropdown-item" href="#">Another action</a></li>
                                    <li><a class="dropdown-item" href="#">Something else here</a></li>
                                </ul>
                            </div>
                            <div class="d-flex align-items-center"><img class="card-img-top mh-8"
                                    src="../../assets/images/doublesideArrow.svg" alt="Arrow"></div>
                            <div class="dropdown ">
                                <button class="btn btn-secondary dropdown-toggle" type="button"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    Dropdown button
                                </button>
                                <ul class="dropdown-menu">
                                    <li><a class="dropdown-item" href="#">Action</a></li>
                                    <li><a class="dropdown-item" href="#">Another action</a></li>
                                    <li><a class="dropdown-item" href="#">Something else here</a></li>
                                </ul>
                            </div>
                        </div>
                    </div> -->
            <div class="d-flex align-items-center mb-2">

                <div>
                    <div class="vehicle-score-value">{{statisticsData[0]?.value}}km</div>
                    <div class="vehicle-profile-header">Duration Distance</div>
                </div>
                <div class="vehicle-rounded-rep">
                    <div class="d-flex align-items-center flex-column justify-content-center">
                        <div class="vehicle-score-value">{{statisticsData[1]?.value}}</div>
                        <div class="vehicle-profile-header">Rider Score</div>
                    </div>
                </div>
            </div>

            <div class="club-of-cards mb-2">

                <div class="d-flex align-items-center flex-column justify-content-center">
                    <div class="vehicle-profile-header">Coasting Distance</div>
                    <div class="vehicle-score-value2">{{statisticsData[2]?.value}}km <sup class="good-tag">good</sup>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-column justify-content-center">
                    <div class="vehicle-profile-header">Cruising Distance</div>
                    <div class="vehicle-score-value2">{{statisticsData[3]?.value}}km <sup class="good-tag">good</sup>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-column justify-content-center">
                    <div class="vehicle-profile-header">Sweatsport Distance</div>
                    <div class="vehicle-score-value2">{{statisticsData[4]?.value}}km <sup class="bad-tag">bad</sup>
                    </div>
                </div>
                <div class="d-flex align-items-center flex-column justify-content-center">
                    <div class="vehicle-profile-header">Top Gear Distance</div>
                    <div class="vehicle-score-value2">{{statisticsData[5]?.value}}km <sup class="good-tag">good</sup>
                    </div>
                </div>
            </div>
            <div class="vehicle-profile-header">Next Service</div>
            <div class="d-flex justify-content-center align-items-center gap20">
                <div
                    class="d-flex align-items-center flex-column justify-content-center flex-column bg-style-dis bx-shadow ">
                    <div class="vehicle-profile-header">Distance</div>
                    <div class="vehicle-score-value2">{{statisticsData[6]?.value}}km</div>

                </div>
                <div
                    class="d-flex align-items-center flex-column justify-content-center flex-column bg-style-dis bx-shadow">
                    <div class="vehicle-profile-header">Date</div>
                    <div class="vehicle-score-value2">13/10/2023</div>
                </div>
            </div>
        </div>
        <div *ngIf="!statisticsData.length">
            <div class="d-flex justify-content-center align-items-center">
                <div class="text-center image-style"> <img src="../../../assets/images/nodata.svg" alt="no-data">
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="!attributeDataList?.length && !statisticsData.length && !masterLeafletData.length">
        <div class="d-flex justify-content-center align-items-center">
            <div class="text-center image-style"> <img src="../../../assets/images/nodata.svg" alt="no-data">
            </div>
        </div>
    </div>
    <!-- <mat-tab>
            <ng-template mat-tab-label>
                <span class="tab-icon"><i class="fa fa-play fa-lg" aria-hidden="true"></i></span>
                Ride status
            </ng-template>
            <div class="w-100" *ngIf="tabIndex===1">
                <app-ride-status [entityId]="entityId"></app-ride-status>
            </div>
        </mat-tab> -->
</div>